import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PropertyCheckOutTaskValidation } from 'uplisting-frontend/validations';

export default class PropertyCheckOutTaskRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-check-out-task']
> {
  recordName = 'property-check-out-task';
  implementMethods = ['query', 'buildChangeset'];

  validation = PropertyCheckOutTaskValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-check-out-task': PropertyCheckOutTaskRepositoryService;
  }
}
